import { type RoleResource } from '@/features/iam/api/resources/role'
import { type RoleProps } from '@/features/iam/roles/Role'
import { maybeParseDate } from '@/utils/date-util'

export function mapRoleResourceToProps(
  resource: RoleResource,
): Partial<RoleProps> {
  return {
    id: resource.id,
    name: resource.name,
    isOwnerRole: resource.is_owner_role,
    description: resource.description,
    workspaceId: resource.workspace_id,
    dateCreated: maybeParseDate(resource.date_created),
    dateModified: maybeParseDate(resource.date_modified),
  }
}
